export default __webpack_public_path__ + "61e9c376bb372ee291d99a211729523e.png";